import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!

  return (_openBlock(), _createBlock(_component_InlineSvg, {
    class: _normalizeClass(["a-icon", _ctx.classes]),
    fill: "currentColor",
    "aria-label": _ctx.label,
    src: require(`../../../static/icons/${_ctx.icon}.svg`)
  }, null, 8, ["class", "aria-label", "src"]))
}